import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export default function PaymentType({
  currency,
  currencies,
  setCurrency,
  defaultCurrency = 'ETH',
  isStore = false,
}) {
  const handleSetSelection = (e) => {
    setCurrency(e.target.value);
  };

  return (
    <FormControl
      sx={{
        width: '100%',
        marginBottom: isStore ? 0 : '24px',
        maxWidth: isStore ? '250px' : 'inherit',
      }}
    >
      <InputLabel id="currencyLabel">Select Payment Type</InputLabel>
      <Select
        label="Select Payment Type"
        labelId="currencyLabel"
        name="currency"
        id="currency"
        data-core-qa="fundPaymentCurrencySelect"
        onChange={handleSetSelection}
        defaultValue={defaultCurrency}
        value={currency}
        size="small"
      >
        {currencies?.length > 0 ? (
          currencies
            .filter((currency) => currency.allowPurchases)
            .map((currency) => (
              <MenuItem
                key={currency.key}
                value={currency.key}
                data-core-qa={`fundPayment${currency.symbol}`}
              >
                {currency.symbol}
              </MenuItem>
            ))
        ) : (
          <MenuItem value="ETH" data-core-qa={`fundPaymentETH`}>
            ETH
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
}
